import { Box, Button, Modal, MobileStepper, Typography } from '@mui/material';
import React, { useState } from 'react';

// Importar imágenes con nombres únicos
import trackingSectionImg from '../../assets/images/tour/tracking_section.webp';
import trackingSectionFullScreenImg from '../../assets/images/tour/tracking_section_fullScreen.webp';

import reportsSectionEventsImg from '../../assets/images/tour/reports_section_events.webp';
import reportsSectionScheduleImg from '../../assets/images/tour/reports_section_schedule.webp';
import reportsSectionStatsImg from '../../assets/images/tour/reports_section_stats.webp';

import adminSectionDevicesImg from '../../assets/images/tour/administration_section_devices.webp';
import adminSectionSchedulesImg from '../../assets/images/tour/administration_section_schedules.webp';
import adminSectionNewScheduleImg from '../../assets/images/tour/administration_section_newSchedule.webp';
import adminSectionSeveralSchedulesImg from '../../assets/images/tour/administration_section_severalSchedules.webp';
import adminSectionCheckpointsImg from '../../assets/images/tour/administration_section_checkpoints.webp';
import adminSectionModifyRouteImg from '../../assets/images/tour/administration_section_modifyRoute.webp';


// Datos de los pasos con imágenes y descripciones
const steps = [
    {
        title: 'Sección de seguimiento',
        description: 'La sección "Seguimiento de flotas" proporciona una vista en tiempo real del estado y ubicación de los vehículos en operación. Aquí puedes visualizar estadísticas clave y la ubicación en el mapa de cada vehículo en movimiento.',
        image: trackingSectionImg
    },
    {
        title: 'Checadas en pantalla completa',
        description: 'Visualiza las checadas de las flotas vehiculares en pantalla completa para un análisis más detallado.',
        image: trackingSectionFullScreenImg
    },
    {
        title: 'Reportes por eventos',
        description: 'Esta pantalla permite visualizar los eventos generados por la flota en tiempo real. Se muestra una tabla con la lista de vehículos, los puntos de control donde han registrado su paso, la hora de registro, el número de vuelta y su estado (adelantado, en tiempo o atrasado). También incluye opciones para filtrar por vehículo, punto de control y estatus, así como la posibilidad de ocultar valores nulos.',
        image: reportsSectionEventsImg
    },
    {
        title: 'Reportes por horario',
        description: 'Esta vista organiza los reportes de flota por horario programado, mostrando las horas en las que cada vehículo debería haber pasado por los diferentes puntos de control. Se permite seleccionar un horario específico para comparar los tiempos reales contra los programados.',
        image: reportsSectionScheduleImg
    },
    {
        title: 'Reportes por estadísticas',
        description: 'Aquí se muestran estadísticas avanzadas sobre el desempeño de la flota, incluyendo el número total de eventos registrados, la puntualidad de los vehículos, y la distribución de eventos en tiempo, adelantados o atrasados. También se incluyen métricas sobre la diferencia máxima de tiempo y el tiempo acumulado.',
        image: reportsSectionStatsImg
    },
    {
        title: 'Administración de dispositivos',
        description: 'Esta vista permite gestionar los dispositivos de rastreo asignados a los vehículos. Se muestra un listado con los vehículos registrados, su estado (activo/inactivo) y el horario asignado a cada uno.',
        image: adminSectionDevicesImg
    },
    {
        title: 'Administración de horarios',
        description: 'Administra los horarios de las flotas y ajusta las rutas según las necesidades operativas.',
        image: adminSectionSchedulesImg
    },
    {
        title: 'Creación de nuevo horario',
        description: 'En esta interfaz, los usuarios pueden crear un nuevo horario para los vehículos de la flota, estableciendo parámetros como el punto de control inicial y final, la hora de inicio, el número de vueltas y la diferencia de tiempo entre puntos.',
        image: adminSectionNewScheduleImg
    },
    {
        title: 'Creación de múltiples horarios',
        description: 'Aquí se permite la creación de múltiples horarios de forma simultánea, especificando un intervalo de minutos entre cada uno. Se pueden definir detalles como el nombre del horario, la asignación de vehículos y los puntos de control inicial y final.',
        image: adminSectionSeveralSchedulesImg
    },
    {
        title: 'Administración de puntos de control',
        description: 'En esta sección, los usuarios pueden administrar y modificar los puntos de control dentro de las rutas establecidas. Se listan todos los puntos de control actuales con la opción de ver detalles o realizar modificaciones.',
        image: adminSectionCheckpointsImg
    },
    {
        title: 'Modificar ruta',
        description: 'Esta ventana emergente permite modificar la ruta general, mostrando una lista de los puntos de control disponibles. Los usuarios pueden omitir ciertos puntos o ajustarlos según sea necesario antes de confirmar la nueva ruta.',
        image: adminSectionModifyRouteImg
    }
];


const StepperModal = ({ open, onClose }) => {
    const [activeStep, setActiveStep] = useState(0);

    const handleNext = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep((prev) => prev + 1);
        } else {
            onClose(); // Cierra el modal cuando se finaliza
            setActiveStep(0); // Reinicia el paso a la primera pantalla
        }
    };

    const handleBack = () => {
        if (activeStep > 0) {
            setActiveStep((prev) => prev - 1);
        }
    };

    const handleSkip = () => {
        onClose(); // Cierra el modal inmediatamente
        setActiveStep(0); // Reinicia los pasos
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box className='route_modal_container' sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '70vw',
                height: '90vh',
                bgcolor: 'var(--color-white)',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'auto',
            }}>
                {/* Título del paso */}
                <h1 style={{ marginBottom: '1rem', fontSize: '1.9rem' }}>{steps[activeStep].title}</h1>

                {/* Imagen del paso */}
                <Box component="div" sx={{ margin: 'auto 0' }}>
                    <Box component="div" sx={{ margin: '0 auto', width: '80%', borderRadius: 2 }} >
                        <Box component="img"
                            src={steps[activeStep].image}
                            alt={steps[activeStep].title}
                            sx={{ width: '100%', height: 'auto', mb: 3 }}
                        />
                    </Box>

                    {/* Descripción del paso */}
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        {steps[activeStep].description}
                    </Typography>
                </Box>
                {/* Mobile Stepper con "dots" */}
                <MobileStepper
                    variant="dots"
                    steps={steps.length}
                    position="static"
                    activeStep={activeStep}
                    nextButton={
                        <Button size="small" onClick={handleNext}>
                            {activeStep === steps.length - 1 ? "Finalizar" : "Siguiente"}
                        </Button>
                    }
                    backButton={
                        <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                            Atrás
                        </Button>
                    }
                    sx={{ marginTop: 'auto', backgroundColor: 'var(--color-white)' }}
                />

                {/* Botón para omitir la configuración */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button color="primary" onClick={handleSkip}>Salir</Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default StepperModal;
